{
  "manager": {
    "productCategoryCreate": {
      "pageTitle": "Create Category",
      "submitLabel": "Create Category"
    },
    "productCategoryEdit": {
      "pageTitle": "Edit Category",
      "submitLabel": "Save Category"
    },
    "productTagCreate": {
      "pageTitle": "Create Tag",
      "submitLabel": "Create Tag"
    },
    "productTagEdit": {
      "pageTitle": "Edit Tag",
      "submitLabel": "Save Tag"
    },
    "productCreate": {
      "pageTitle": "Create Product",
      "saveAndCreateAnother": "Save & Create Another"
    },
    "productForm": {
      "nameLabel": "Name *",
      "namePlaceholder": "Enter a name for the product",
      "priceLabel": "Cost Per Quantity *",
      "applyTaxLabel": "Apply tax rates to this product",
      "nameRequired": "A product name is required"
    },
    "bookableEntityProducts": {
      "noLimit": "No limit",
      "columnName": "Name",
      "columnPrice": "Price",
      "columnMaxPerCart": "Max Per Cart"
    },
    "formCreateEditProduct": {
      "productDetails": "Product Details",
      "productName": "Product Name",
      "fieldRequired": "This field is required.",
      "productNamePlaceholder": "Enter product name...",
      "productPrice": "Product Price",
      "productPriceInvalid": "Product price must be 0 (free) or between 0.5 and 999,999.99",
      "productDescription": "Product Description",
      "productDescriptionPlaceholder": "Enter product description...",
      "applyTax": "Apply Tax",
      "applyTaxHelp": "Include applicable taxes for this product"
    },
    "formCreateEditProductCategory": {
      "detailsTitle": "Category Details",
      "nameLabel": "Category Name",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter category name...",
      "descriptionLabel": "Category Description",
      "descriptionPlaceholder": "Enter category description...",
      "associatedProductsTitle": "Associated Products",
      "columnName": "Name",
      "columnPrice": "Price",
      "columnDescription": "Description",
      "columnAssociated": "Associated"
    },
    "formCreateEditProductTag": {
      "detailsTitle": "Tag Details",
      "nameLabel": "Tag Name",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter tag name...",
      "associatedProductsTitle": "Associated Products",
      "columnName": "Name",
      "columnPrice": "Price",
      "columnDescription": "Description",
      "columnAssociated": "Associated"
    },
    "productSearchOrCreate": {
      "searchPlaceholder": "Search for a product",
      "typeToSearch": "Type to search through all {count} items"
    },
    "storeProgramForm": {
      "scheduleType": "Schedule Type"
    },
    "productCategoryIndex": {
      "title": "Product Categories"
    },
    "productCategoryShow": {
      "categoryOverview": "Category Overview",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "noDescription": "No description provided",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "assignedProducts": "Assigned Products",
      "noProductsAssigned": "No products assigned to this category.",
      "nameColumn": "Name",
      "priceColumn": "Price",
      "statusColumn": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "loadFailed": "Failed to load category.",
      "backToCategories": "Back to Categories",
      "headTitle": "View Category",
      "deleteWarning": "This will permanently delete the category \"{name}\". Products assigned to this category will not be affected.",
      "loadFailedToast": "Failed to load category",
      "notApplicable": "N/A"
    },
    "productTagIndex": {
      "title": "Product Tags"
    },
    "productTagShow": {
      "overviewTitle": "Tag Overview",
      "nameLabel": "Name",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "assignedProductsTitle": "Assigned Products",
      "noProductsAssigned": "No products assigned to this tag.",
      "priceLabel": "Price",
      "statusLabel": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "loadFailed": "Failed to load tag.",
      "backToTags": "Back to Tags",
      "headTitle": "View Tag",
      "deleteWarning": "This will permanently delete the tag \"{name}\". Products assigned to this tag will not be affected.",
      "loadFailedToast": "Failed to load tag",
      "notApplicable": "N/A"
    },
    "productIndex": {
      "title": "Products",
      "assignCategories": "Assign Categories",
      "assignTags": "Assign Tags",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "selectCategoriesLabel": "Select Categories *",
      "searchCategoriesPlaceholder": "Search for categories",
      "categoryRequired": "At least one category selection is required.",
      "selectTagsLabel": "Select Tags *",
      "searchTagsPlaceholder": "Search for tags",
      "tagRequired": "At least one tag selection is required.",
      "productEntity": "Product",
      "assignCategoriesError": "Error assigning categories. Please try again.",
      "assignTagsError": "Error assigning tags. Please try again."
    },
    "productShow": {
      "archivedAlert": "This product is archived.",
      "overviewTitle": "Product Overview",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "noDescription": "No description provided",
      "priceLabel": "Price",
      "taxAppliedLabel": "Tax Applied",
      "statusLabel": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "categoriesLabel": "Categories",
      "noCategories": "No categories",
      "tagsLabel": "Tags",
      "noTags": "No tags",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "invoicePaid": "Paid",
      "invoiceUnpaid": "Unpaid",
      "bookingStateActive": "Active",
      "headTitle": "View Product",
      "deleteWarning": "This will permanently delete the product {name}.  Invoices that contain this product will not be affected and historical data will remain intact.",
      "columnInvoiceNumber": "Invoice #",
      "columnCreated": "Created",
      "columnAmount": "Amount",
      "columnStatus": "Status",
      "tabInvoices": "Invoices",
      "tabTransactions": "Transactions",
      "tabFacilities": "Facilities",
      "tabBookings": "Bookings"
    },
    "modalCreateProduct": {
      "title": "Create Product",
      "createProduct": "Create Product"
    },
    "modalEditProduct": {
      "title": "Edit Product",
      "updateProduct": "Update Product"
    },
    "productEdit": {
      "title": "Edit Product",
      "saveProduct": "Save Product"
    }
  }
}
